import '../constants/const.css';
import './css/pagePlanResult.css';

import React, { useState, useEffect } from 'react';
import { Dayjs } from '../logic/classDayjs';
import PitGraph from '../components/planResult/pitGraph';
import AshGraph from '../components/planResult/ashGraph';
import ElectricGraph2 from '../components/planResult/electricGraph2';
import ElectricSumGraph2 from '../components/planResult/electricSumGraph2';
import BurnGraph2 from '../components/planResult/burnGraph2';
import BurnGraph3 from '../components/planResult/burnGraph3';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';

import { JsonResponse, REQ_PAST_RESULT, useApi } from '../logic/classApi';
import { LoginService } from '../logic/loginService';

import {
  DayContext,
  DayContextObject,
  DriveContext,
  DriveContextObject,
  DraftContext,
  DraftContextObject,
  ConditionContext,
  ConditionContextObject,
  MainContext,
  MainContextObject,
} from '../entities/planResult';
import { showErrorMessage, ShownError, showWarningMessage } from '../components/appPane';
import { MESSAGES } from '../constants/const';
import { getCurrentFiscalYear } from '../logic/util';

const FONT_SIZE_14 = 14;
const FONT_SIZE_18 = 18;
const SELECT_MONTH_INDEX = 0;

const BURNLOAD_DIGIT = 0;
const CARRY_BLUR_DIGIT = 1;
const BURNVOLUME_BLUR_DIGIT = 1;
const TRASH_PIT_DIGIT = 0;

const months: number[] = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
const DEF_MONTH_NUMS: number[] = [30, 31, 30, 31, 31, 30, 31, 30, 31, 31, 28, 31];

const CELL_HEIGHT = '25px';
const CELL_WIDTH = '70px';

const item_carry_volume: string = 'carry_volume';
const item_burn_volume: string = 'burn_volume';
const item_burn_load: string = 'burn_load';
const item_trash_pit_rest: string = 'trash_pit_rest';
const item_electric_sale: string = 'electric_sale';
const item_electric_create: string = 'electric_create';
const item_main_ash_carry: string = 'main_ash_carry';
const item_fly_ash_carry: string = 'fly_ash_carry';
const item_main_ash_unit: string = 'main_ash_unit';
const item_fly_ash_unit: string = 'fly_ash_unit';
const item_shutdown_date: string = 'shutdown_date';
const item_launch_date: string = 'launch_date';

const colorList: string[] = ['#8ed48f', '#8ea5d4', '#d4be8e', '#c28ed4', '#948982'];

function getCalendarYear(year: number, monNum: number): number {
  if (monNum <= 3) {
    year = Number(year) + 1;
  }
  return year;
}

function formatTwoDigits(num: number): string {
  return num.toString().padStart(2, '0');
}

function calcDecimalSum(value1: number, value2: number) {
  const digitVal1: number = String(value1).indexOf('.') > 0 ? String(value1).length - String(value1).indexOf('.') - 1 : 0;
  const digitVal2: number = String(value2).indexOf('.') > 0 ? String(value2).length - String(value2).indexOf('.') - 1 : 0;
  const digit: number = Math.max(digitVal1, digitVal2);
  const largeVal1: number = parseInt((value1.toFixed(digit) + '').replace('.', ''));
  const largeVal2: number = parseInt((value2.toFixed(digit) + '').replace('.', ''));
  const sumLarge: number = largeVal1 + largeVal2;
  const ret: number = sumLarge / 10 ** digit;
  return ret;
}

function addComma(value: number): string {
  const strValue: string = String(value);
  const disit: number = strValue.indexOf('.');
  const formatter = new Intl.NumberFormat('ja-JP');
  if (disit <= 0) {
    return formatter.format(Number(strValue));
  } else {
    let intValue: string = strValue.substring(0, disit);
    let pointValue: string = strValue.substring(disit, strValue.length);
    return formatter.format(Number(intValue)) + pointValue;
  }
}

function calcMathRound(value: number, digit: number) {
  if (digit < 0) {
    return value;
  }
  const val1: number = value * 10 ** digit;
  const val2: number = Math.round(val1);
  const ret: number = val2 / 10 ** digit;
  return ret;
}

function calcMathFloor(value: number, digit: number) {
  if (digit < 0) {
    return value;
  }
  const val1: number = value * 10 ** digit;
  const val2: number = Math.floor(val1);
  const ret: number = val2 / 10 ** digit;
  return ret;
}

function sumArray(numbers: number[]): number {
  let sumNum: number = 0;
  for (let i = 0; i < numbers.length; i++) {
    sumNum = calcDecimalSum(sumNum, numbers[i]);
  }
  return sumNum;
}

const screenStyle: React.CSSProperties = {
  display: 'grid',
  backgroundColor: '#e9e9e9',
  height: '100%',
  width: '100%',
  position: 'sticky',
  padding: '20px',
};

const headerStyle: React.CSSProperties = {
  position: 'relative',
  backgroundColor: '#007f89',
  height: '45px',
  width: '98%',
  borderRadius: '5px',
  padding: '5px',
};
const indentStyle: React.CSSProperties = {
  backgroundColor: '#FFFFFF',
  width: '98%',
  borderRadius: '5px',
  overflowX: 'auto',
};
const rowStyle: React.CSSProperties = {
  backgroundColor: 'transparent',
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  paddingTop: '5px',
  paddingBottom: '5px',
  paddingLeft: '10px',
  paddingRight: '10px',
};

const buttonStyle: React.CSSProperties = {
  marginLeft: '3px',
  marginRight: '3px',
  whiteSpace: 'nowrap',
};

const l2_PlanSheetStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  overflowX: 'auto',
  border: '1px solid #424242',
};
const l1_BurnGraphStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
};
const l1_PlanGraphStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
};
const l2_PlanGraphStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  padding: '10px',
  width: '100%',
};

const planCarryRowStyle: React.CSSProperties = {
  backgroundColor: '#e9e9e9',
  border: '1px solid #000000',
  overflowX: 'auto',
  height: CELL_HEIGHT,
  minHeight: CELL_HEIGHT,
};
const planCarryAnCellStyle: React.CSSProperties = {
  border: '1px solid #000000',
  textAlign: 'center',
  minWidth: '60px',
  height: CELL_HEIGHT,
  minHeight: CELL_HEIGHT,
  fontSize: FONT_SIZE_18,
};
const planCarryAnDoubleCellStyle: React.CSSProperties = { ...planCarryAnCellStyle, minWidth: '120px' };
const planCarryCellStyle: React.CSSProperties = {
  border: '1px solid #000000',
  textAlign: 'center',
  width: CELL_WIDTH,
  minWidth: CELL_WIDTH,
  height: CELL_HEIGHT,
  minHeight: CELL_HEIGHT,
  fontSize: FONT_SIZE_14,
};

const graphTitleStyle: React.CSSProperties = {
  textAlign: 'left',
  flexBasis: '9em',
  marginLeft: '5px',
  pointerEvents: 'none',
  alignContent: 'end',
};

const graphTitleBackStyle: React.CSSProperties = {
  background: '#e9e9e9',
  height: '25px',
  width: '130px',
  borderRadius: '5px',
  pointerEvents: 'none',
  paddingLeft: '10px',
  marginLeft: '-5px',
};

const Page = () => {
  // 画面操作
  const [isReload, setIsReload] = useState<boolean>(true);
  const [selectMonthIndex, setSelectMonthIndex] = useState<number>(SELECT_MONTH_INDEX);
  const [displayDays, setDisplayDays] = useState<number[][]>([DEF_MONTH_NUMS, DEF_MONTH_NUMS]);
  const [displayYearList, SetDisplayYearList] = useState<number[]>([new Date().getFullYear()]);
  const [showShutdownVisible, setShowShutdownVisible] = useState<boolean>(true);
  const [showPitVisible, setShowPitVisible] = useState<boolean>(true);
  const [showBurnVisible, setShowBurnVisible] = useState<boolean>(true);
  const [showPowerVisible, setShowPowerVisible] = useState<boolean>(true);
  const [showAshVisible, setShowAshVisible] = useState<boolean>(true);

  // サーバ操作
  const [isResultDraft, setIsResultDraft] = useState<boolean[]>([] as boolean[]);
  const [isYearSelect, setIsSelectYear] = useState<boolean[]>([] as boolean[]);
  const [mainResource, setMainResource] = useState<MainContext>(new MainContextObject());
  const [draftResource, setDraftResource] = useState<DraftContext[]>([] as DraftContextObject[]);
  const [conditionResource, setConditionResource] = useState<ConditionContext>(new ConditionContextObject());
  const [sessionFurnacesCount, setSessionFurnacesCount] = useState<number>(LoginService.getLoginInfo().furnacesCount);
  const [resultBurnLoads, setResultBurnLoads] = useState<number[][]>([
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
  ]);

  const { getRequest } = useApi((window as any).subWindow);

  useEffect(() => {
    if (isReload) {
      (async () => {
        try {
          const requestUrl = `${REQ_PAST_RESULT}?branchId=${String(LoginService.getLoginInfo().branchId)}&selectDate=${getSelectDate()}&furnaces=${String(
            LoginService.getLoginInfo().furnacesCount,
          )}`;
          let { payload: json } = await getRequest<JsonResponse>(requestUrl);
          // OriginData
          if (true) {
            const resource: ConditionContext = new ConditionContextObject();
            const originData = json.originData[0];
            resource.mainAshUnit = Number(originData.ash_rate);
            resource.flyAshUnit = Number(originData.fly_ash_rate);
            resource.pitMin = Number(originData.pit_min);
            resource.pitMax = Number(originData.pit_max);
            resource.rateCapacity = Number(originData.rate_capacity);
            resource.trashDensity = Number(originData.trash_density);
            // resource.weeklyCarryCalculation = originData.weekly_carry_calculation;
            setConditionResource(resource);
          }
          // Main
          const mainResource: MainContext = new MainContextObject();
          mainResource.active_year = String(new Date(json.activeYear).getFullYear());
          let yearList: number[] = [] as number[];
          for (let i = 0; i < json.yearItems.length; i++) {
            yearList.push(json.yearItems[i]);
          }
          yearList = yearList.sort((small, large) => large - small);
          for (let i = 0; i < json.yearItems.length; i++) {
            mainResource.year_list.push(String(yearList[i]));
          }
          setMainResource(mainResource);
          //表示年度
          const activeYearList: number[] = [] as number[];
          for (let i = 0; i < json.activeYear.length; i++) {
            activeYearList.push(new Date(json.activeYear[i]).getFullYear());
          }
          activeYearList.sort((small, large) => large - small);
          SetDisplayYearList(activeYearList);
          const isSelectArray: boolean[] = [] as boolean[];
          for (let selectCount = 0; selectCount < yearList.length; selectCount++) {
            let isSelect: boolean = false;
            for (let activeCount = 0; activeCount < activeYearList.length; activeCount++) {
              if (yearList[selectCount] === activeYearList[activeCount]) {
                isSelect = true;
                break;
              }
            }
            isSelectArray.push(isSelect);
          }
          //年度
          setIsSelectYear([...isSelectArray]);
          //過去実績
          const dayCountArray: number[][] = [] as number[][];
          if (true) {
            const draftArray: DraftContext[] = [] as DraftContext[];
            for (let draftIndex = 0; draftIndex < json.resultData.length; draftIndex++) {
              const dayCounts: number[] = [];
              for (let monIndex = 0; monIndex < months.length; monIndex++) {
                const dateStr: string = String(getCalendarYear(activeYearList[draftIndex], months[monIndex])).concat(
                  '-'.concat(formatTwoDigits(months[monIndex]).concat('-').concat(formatTwoDigits(1))),
                );
                dayCounts.push(Dayjs.getAllDaysInMonth(dateStr).length);
              }
              dayCountArray.push(dayCounts);
              // const dayAllSum: number = daySum(draftIndex, dayCounts.length);
              const dayAllSum: number = sumArray(dayCounts);
              const furnacesCount: number = LoginService.getLoginInfo().furnacesCount;
              const dateArray: string[] = [] as string[];
              for (let monIndex = 0; monIndex < dayCounts.length; monIndex++) {
                for (let j = 0; j < dayCounts[monIndex]; j++) {
                  const dateStr: string = String(getCalendarYear(activeYearList[draftIndex], months[monIndex])).concat(
                    '-'.concat(
                      formatTwoDigits(months[monIndex])
                        .concat('-')
                        .concat(formatTwoDigits(j + 1)),
                    ),
                  );
                  dateArray.push(dateStr);
                }
              }
              console.log(dateArray);
              const resourceDraft: DraftContext = getDraftContext(
                json.resultData[draftIndex].resultDay,
                json.resultData[draftIndex].resultMonth,
                json.resultData[draftIndex].resultShutDown,
                dateArray,
                dayAllSum,
                furnacesCount,
              );
              draftArray.push(resourceDraft);
            }
            setDraftResource(draftArray);
            // setJsonDraftResource(defaultAutoDraftResource);
            // console.log(draftArray);
            setIsResultDraft([...new Array(json.resultData.length).fill(true)]);
          }
          // 日付
          setDisplayDays(dayCountArray);
        } catch (e) {
          // await showErrorMessage(MESSAGES.ERROR_SERVER, { window: (window as any).subWindow });
          // getRequest側でメッセージが出るより先にたどり着くため、こちらでメッセージを表示する
          if (e instanceof ShownError) {
            await showErrorMessage(e.message, { window: (window as any).subWindow });
          }
          (window as any).subWindow.close();
          console.error(e);
          return;
        }
      })();
      setIsReload(false);
    }
  }, [isReload]);

  useEffect(() => {
    if (draftResource.length > 0) {
      const draftArray: number[][] = [] as number[][];
      for (let draftIndex = 0; draftIndex < draftResource.length; draftIndex++) {
        const draftMiniArray: number[] = [];
        for (let furnacesIndex = 0; furnacesIndex < LoginService.getLoginInfo().furnacesCount; furnacesIndex++) {
          draftMiniArray.push(calcMathFloor(calcBurnLoad(draftResource[draftIndex].day, draftIndex, furnacesIndex, conditionResource.rateCapacity), BURNLOAD_DIGIT));
        }
        draftArray.push(draftMiniArray);
      }
      setResultBurnLoads(draftArray);
    }
  }, [conditionResource.rateCapacity, draftResource]);

  // 判定
  const isMonthDisplay = () => {
    return selectMonthIndex === SELECT_MONTH_INDEX;
  };

  // 画面の表示切替
  const handleMonthClick = (monthIndex: number) => {
    setSelectMonthIndex(monthIndex);
  };

  const handleShowShutdownClick = () => {
    setShowShutdownVisible(!showShutdownVisible);
  };
  const handleShowPitClick = () => {
    setShowPitVisible(!showPitVisible);
  };
  const handleShowBurnClick = () => {
    setShowBurnVisible(!showBurnVisible);
  };
  const handleShowPowerClick = () => {
    setShowPowerVisible(!showPowerVisible);
  };
  const handleShowAshClick = () => {
    setShowAshVisible(!showAshVisible);
  };
  const handleSelectYearClick = (index: number) => {
    const temp: boolean[] = [...isYearSelect]; // 新たに生成した配列で上書きすることでReactが検知する
    let selectCount: number = 0;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i]) {
        selectCount = selectCount + 1;
      }
    }
    if (isYearSelect[index] && selectCount <= 1) {
      showWarningMessage('取得年度を未選択にはできません', false, { window: (window as any).subWindow });
    } else {
      temp[index] = !isYearSelect[index];
      setIsSelectYear(temp);
      setIsReload(true);
    }
  };

  const getDriveContext = (driveResource: any, furnacesCount: number): DriveContext => {
    const resourceDrive: DriveContext = new DriveContextObject(0, furnacesCount);
    if (driveResource && driveResource.hasOwnProperty('resultDate')) {
      resourceDrive.date = driveResource.resultDate;
    }
    resourceDrive.carry_volume = Number(driveResource.carryVolume ?? 0);
    for (let i = 0; i < sessionFurnacesCount; i++) {
      resourceDrive.burn_volume[i] = Number(driveResource.burnVolume[i] ?? 0);
    }
    resourceDrive.electric_create = Number(driveResource.electricCreate ?? 0);
    resourceDrive.electric_sale = Number(driveResource.electricSale ?? 0);
    resourceDrive.main_ash_carry_out = Number(driveResource.mainAshCarryOut ?? 0);
    resourceDrive.fly_ash_carry_out = Number(driveResource.flyAshCarryOut ?? 0);
    resourceDrive.main_ash_carry_out_units = Number(driveResource.mainAshCarryOutUnits ?? 0);
    resourceDrive.fly_ash_carry_out_units = Number(driveResource.flyAshCarryOutUnits ?? 0);
    resourceDrive.trash_pit_rest = Number(driveResource.trashPitRest ?? 0);
    return resourceDrive;
  };

  const getDriveMonthContext = (driveResource: any, furnacesCount: number): DriveContext => {
    const resourceDrive: DriveContext = new DriveContextObject(0, furnacesCount);
    if (driveResource && driveResource.hasOwnProperty('resultMonthDate')) {
      resourceDrive.date = driveResource.resultMonthDate;
    }
    resourceDrive.carry_volume = Number(driveResource.carryVolume ?? 0);
    for (let i = 0; i < sessionFurnacesCount; i++) {
      resourceDrive.burn_volume[i] = Number(driveResource.burnVolume[i] ?? 0);
    }
    for (let i = 0; i < sessionFurnacesCount; i++) {
      resourceDrive.burn_load[i] = Number(driveResource.burnLoad[i] ?? 0);
    }
    resourceDrive.electric_create = Number(driveResource.electricCreate ?? 0);
    resourceDrive.electric_sale = Number(driveResource.electricSale ?? 0);
    resourceDrive.main_ash_carry_out = Number(driveResource.mainAshCarryOut ?? 0);
    resourceDrive.fly_ash_carry_out = Number(driveResource.flyAshCarryOut ?? 0);
    resourceDrive.main_ash_carry_out_units = Number(driveResource.mainAshCarryOutUnits ?? 0);
    resourceDrive.fly_ash_carry_out_units = Number(driveResource.flyAshCarryOutUnits ?? 0);
    return resourceDrive;
  };

  const getDayContext = (shutdownArray: any): DayContext => {
    const resourceDrive: DayContext = new DayContextObject();
    resourceDrive.shutdown_date = shutdownArray.shutdownDate;
    resourceDrive.launch_date = shutdownArray.launchDate;
    resourceDrive.not_change_flag = shutdownArray.notChangeFlag;
    return resourceDrive;
  };

  const getDraftContext = (planDay: any, planMonth: any, planShutDown: any, dateArray: string[], dayAllSum: number, furnacesCount: number): DraftContext => {
    const resourceDraft: DraftContext = new DraftContextObject(0, furnacesCount);
    const dayArray: DriveContext[] = [] as DriveContext[];
    let dateIndex: number = 0;
    for (let i = 0; i < dayAllSum; i++) {
      let date: string = '';
      if (planDay.length <= dateIndex) {
        date = '';
      } else if (planDay[dateIndex] && planDay[dateIndex].hasOwnProperty('resultDate')) {
        date = planDay[dateIndex].resultDate;
      } else {
        // console.log(dateArray[i]);
      }
      // console.log(date);
      if (dateArray[i] === date) {
        dayArray.push(getDriveContext(planDay[dateIndex], furnacesCount));
        dateIndex = dateIndex + 1;
      } else {
        dayArray.push(new DriveContextObject(0, furnacesCount));
      }
    }
    resourceDraft.day = dayArray;
    const monthArray: DriveContext[] = [] as DriveContext[];
    let monthIndex: number = 0;
    for (let i = 0; i < months.length; i++) {
      let date: string = '';
      if (planMonth.length <= monthIndex) {
        date = '';
      } else if (planMonth[monthIndex] && planMonth[monthIndex].hasOwnProperty('resultMonthDate')) {
        date = planMonth[monthIndex].resultMonthDate;
      } else {
        // console.log(dateArray[i]);
      }
      const monthStr: string = formatTwoDigits(Number(date.split('-')[1])).trim();
      if (formatTwoDigits(months[i]).trim() === monthStr.trim()) {
        monthArray.push(getDriveMonthContext(planMonth[monthIndex], furnacesCount));
        monthIndex = monthIndex + 1;
      } else {
        monthArray.push(new DriveContextObject(0, furnacesCount));
      }
    }
    resourceDraft.month = monthArray;
    const shutdownArray: DayContext[][] = [] as DayContext[][];
    for (let furnacesIndex = 0; furnacesIndex < furnacesCount; furnacesIndex++) {
      const furnacesDriveArray: DayContext[] = [] as DayContext[];
      if (planShutDown.length === 0) {
        for (let furnacesIndex = 0; furnacesIndex < furnacesCount; furnacesIndex++) {
          const furnacesDriveArray: DayContext[] = [] as DayContext[];
          shutdownArray.push(furnacesDriveArray);
        }
      } else {
        for (let furnacesIndex = 0; furnacesIndex < furnacesCount; furnacesIndex++) {
          const furnacesDriveArray: DayContext[] = [] as DayContext[];
          for (let i = 0; i < planShutDown[furnacesIndex].length; i++) {
            furnacesDriveArray.push(getDayContext(planShutDown[furnacesIndex][i]));
          }
          shutdownArray.push(furnacesDriveArray);
        }
      }
      shutdownArray.push(furnacesDriveArray);
    }
    resourceDraft.shutdown = shutdownArray;
    return resourceDraft;
  };

  //計算
  const calcItemSum = (planData: DriveContext[], itemStr: string): number => {
    let val: number[] = selectItemArray(planData, itemStr);
    let sumVal: number = sumArray(val);
    return sumVal;
  };

  const calcItemBurnSum = (planData: DriveContext[], furnacesIndex: number): number => {
    let val: number[] = selectItemBurnArray(planData, item_burn_volume, furnacesIndex);
    let sumVal: number = sumArray(val);
    return sumVal;
  };

  const calcBurnLoad = (planDatas: DriveContext[], draftIndex: number, furnacesIndex: number, rateCapacity: number): number => {
    const sumVal: number = calcItemBurnSum(planDatas, furnacesIndex);
    const sumDays: number = sumArray(displayDays[draftIndex]);
    const calcRet: number = (sumVal / (sumDays * rateCapacity)) * 100;
    return calcRet;
  };

  function convertMWhArray(valueArray: number[]): number[] {
    const retArray: number[] = [] as number[];
    for (let i = 0; i < valueArray.length; i++) {
      retArray.push(calcMWh(valueArray[i]));
    }
    return retArray;
  }

  function calcMWh(value: number): number {
    const ret: number = Math.round(value / 1000);
    return ret;
  }

  const getMonthData = (dayDatas: DriveContext[], draftIndex: number): DriveContext[] => {
    return dayDatas.slice(daySum(draftIndex, selectMonthIndex - 1), daySum(draftIndex, selectMonthIndex));
  };

  const daySum = (draftIndex: number, numIndex: number): number => {
    if (numIndex === SELECT_MONTH_INDEX || displayDays.length === 0) {
      return 0;
    }
    return sumArray(displayDays[draftIndex].slice(0, numIndex));
  };

  const shutDownSums = (itemStr: string, lShutdown: DayContext[], draftIndex: number): string[] => {
    if (!lShutdown) {
      return [''];
    }
    const startTime: number = new Date(getMinDate(displayYearList[draftIndex])).getTime();
    const endTime: number = new Date(getMaxDate(displayYearList[draftIndex])).getTime();
    let retArray: string[] = [];
    lShutdown.forEach((day) => {
      if (itemStr === item_shutdown_date) {
        const shutdownTime: number = new Date(day.shutdown_date).getTime();
        if (startTime <= shutdownTime && shutdownTime <= endTime) {
          retArray.push(day.shutdown_date);
        }
      } else {
        const launchTime: number = new Date(day.launch_date).getTime();
        if (startTime <= launchTime && launchTime <= endTime) {
          retArray.push(day.launch_date);
        }
      }
    });
    const sortedDates = retArray.sort((a, b) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      return dateA.getTime() - dateB.getTime(); // 昇順
    });
    return sortedDates;
  };

  // 参照補助
  const itemDraftVolumes = (monthContexts: DriveContext[], dayContexts: DriveContext[], itemStr: string, draftIndex: number): number[] => {
    let retArray: number[] = [];
    if (isMonthDisplay()) {
      retArray = selectItemArray(monthContexts, itemStr);
    } else {
      retArray = selectItemArray(dayContexts.slice(daySum(draftIndex, selectMonthIndex - 1), daySum(draftIndex, selectMonthIndex)), itemStr);
    }
    return retArray;
  };

  const selectItemArray = (planData: DriveContext[], itemStr: string): number[] => {
    if (planData.length === 0) {
      return [0]; // dataが読み込み前
    }
    let val: number[] = [] as number[];
    for (let i = 0; i < planData.length; i++) {
      if (itemStr === item_carry_volume) {
        val.push(planData[i].carry_volume);
      } else if (itemStr === item_electric_create) {
        val.push(planData[i].electric_create);
      } else if (itemStr === item_electric_sale) {
        val.push(planData[i].electric_sale);
      } else if (itemStr === item_main_ash_carry) {
        val.push(planData[i].main_ash_carry_out);
      } else if (itemStr === item_fly_ash_carry) {
        val.push(planData[i].fly_ash_carry_out);
      } else if (itemStr === item_main_ash_unit) {
        val.push(planData[i].main_ash_carry_out_units);
      } else if (itemStr === item_fly_ash_unit) {
        val.push(planData[i].fly_ash_carry_out_units);
      } else if (itemStr === item_trash_pit_rest) {
        val.push(planData[i].trash_pit_rest);
      } else {
        val.push(1);
      }
    }
    return val;
  };

  const burnDraftVolumes = (monthContexts: DriveContext[], dayContexts: DriveContext[], itemStr: string, furnacesIndex: number, draftIndex: number): number[] => {
    let retArray: number[] = [];
    if (isMonthDisplay()) {
      retArray = selectItemBurnArray(monthContexts, itemStr, furnacesIndex);
    } else {
      retArray = selectItemBurnArray(dayContexts.slice(daySum(draftIndex, selectMonthIndex - 1), daySum(draftIndex, selectMonthIndex)), itemStr, furnacesIndex);
    }
    return retArray;
  };

  const burnDraftDaysVolumes = (dayContexts: DriveContext[], itemStr: string, furnacesIndex: number, draftIndex: number): number[] => {
    let retArray: number[] = [];
    if (isMonthDisplay()) {
      retArray = selectItemBurnArray(dayContexts, itemStr, furnacesIndex);
    } else {
      retArray = selectItemBurnArray(dayContexts.slice(daySum(draftIndex, selectMonthIndex - 1), daySum(draftIndex, selectMonthIndex)), itemStr, furnacesIndex);
    }
    return retArray;
  };

  const selectItemBurnArray = (planData: DriveContext[], itemStr: string, furnacesIndex: number): number[] => {
    if (planData.length === 0) {
      return [0]; // dataが読み込み前
    }
    let val: number[] = [] as number[];
    for (let i = 0; i < planData.length; i++) {
      if ((itemStr = item_burn_volume)) {
        val.push(planData[i].burn_volume[furnacesIndex]);
      } else if ((itemStr = item_burn_load)) {
        val.push(planData[i].burn_load[furnacesIndex]);
      }
    }
    return val;
  };

  function getSelectDate(): string[] {
    if (mainResource.year_list.length > 0) {
      let yearList: string[] = [] as string[];
      for (let i = 0; i < mainResource.year_list.length; i++) {
        if (isYearSelect[i]) {
          yearList.push(getMinDate(Number(mainResource.year_list[i])));
        }
      }
      if (yearList.length > 0) {
        return yearList;
      } else {
        return [getMinDate(getCurrentFiscalYear() - 1)];
      }
    } else {
      return [getMinDate(getCurrentFiscalYear() - 1)];
    }
  }

  function getMinDate(numYear: number): string {
    return String(numYear).concat('-04-01');
  }

  function getMaxDate(numYear: number): string {
    return String(Number(numYear) + 1).concat('-03-31');
  }

  return (
    <div style={{ ...screenStyle }}>
      <div style={headerStyle}>
        {Array.from({ length: mainResource.year_list.length }).map((_, colIndex) => (
          <Button
            size="sm"
            style={{ ...buttonStyle, backgroundColor: colorList[Number(mainResource.year_list[colIndex]) % colorList.length] }}
            variant={isYearSelect[colIndex] ? 'light' : 'outline-light'}
            onClick={() => handleSelectYearClick(colIndex)}
          >
            {mainResource.year_list[colIndex] + '年度'}
          </Button>
        ))}
      </div>
      <div style={indentStyle}>
        <div style={rowStyle}>
          <Button variant={showShutdownVisible ? 'success' : 'outline-success'} size="sm" onClick={() => handleShowShutdownClick()}>
            立上下日
          </Button>
          <Button variant={showPitVisible ? 'success' : 'outline-success'} size="sm" onClick={() => handleShowPitClick()}>
            ピット残
          </Button>
          <Button variant={showBurnVisible ? 'success' : 'outline-success'} size="sm" onClick={() => handleShowBurnClick()}>
            焼却量・焼却負荷率
          </Button>
          <Button variant={showPowerVisible ? 'success' : 'outline-success'} size="sm" onClick={() => handleShowPowerClick()}>
            発電量・売電量
          </Button>
          <Button variant={showAshVisible ? 'success' : 'outline-success'} size="sm" onClick={() => handleShowAshClick()}>
            主灰・飛灰搬出量
          </Button>
        </div>
        <div style={rowStyle}>
          <ToggleButtonGroup type="radio" defaultValue={0} name="calender">
            {Array.from({ length: months.length + 1 }).map((_, colIndex) => (
              <ToggleButton variant="outline-success" size="sm" onClick={() => handleMonthClick(colIndex)} id={'calender' + colIndex} value={colIndex}>
                {colIndex === 0 ? '年間' : months[colIndex - 1] + '月'}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </div>
      </div>

      <br />

      <div style={indentStyle}>
        <div style={rowStyle}>
          <div style={l2_PlanSheetStyle}>
            <table
              style={{
                borderCollapse: 'collapse',
                position: 'sticky',
                left: 0,
                zIndex: 2,
                width: '180px',
                minWidth: '180px',
                background: '#ffffff',
              }}
            >
              <tbody>
                {Array.from({ length: draftResource.length }).map((_, draftIndex) => (
                  <>
                    <tr
                      style={{
                        ...planCarryRowStyle,
                        display: isResultDraft[draftIndex] ? 'table-row' : 'none',
                      }}
                    >
                      <td
                        style={{
                          ...planCarryAnDoubleCellStyle,
                          background: '#007f89',
                          color: '#FFFFFF',
                          fontSize: FONT_SIZE_14,
                        }}
                        colSpan={2}
                      >
                        {selectMonthIndex === 0
                          ? String(displayYearList[draftIndex]).concat('年')
                          : selectMonthIndex >= 10
                          ? String(displayYearList[draftIndex] + 1).concat('年')
                          : String(displayYearList[draftIndex]).concat('年')}
                        {selectMonthIndex === 0 ? '' : String(months[selectMonthIndex - 1]).concat('月')}
                      </td>
                    </tr>
                    <tr style={{ ...planCarryRowStyle, display: isResultDraft.some((value) => value) ? 'table-row' : 'none' }}>
                      <td
                        style={{
                          ...planCarryAnDoubleCellStyle,
                          fontSize: FONT_SIZE_14,
                        }}
                        colSpan={2}
                      >
                        搬入量
                      </td>
                    </tr>
                    {Array.from({ length: sessionFurnacesCount }).map((_, furnacesIndex) => (
                      <>
                        <tr
                          style={{
                            ...planCarryRowStyle,
                            display: isResultDraft[draftIndex] && showBurnVisible ? 'table-row' : 'none',
                          }}
                        >
                          <td
                            style={{
                              ...planCarryAnCellStyle,
                              fontSize: FONT_SIZE_14,
                            }}
                            rowSpan={isResultDraft[draftIndex] && isMonthDisplay() ? 2 : 1}
                          >
                            {String(furnacesIndex + 1).concat('号炉')}
                          </td>
                          <td style={{ ...planCarryAnCellStyle, fontSize: FONT_SIZE_14 }}> 焼却量</td>
                        </tr>
                        <tr
                          style={{
                            ...planCarryRowStyle,
                            display: isResultDraft[draftIndex] && showBurnVisible && isMonthDisplay() ? 'table-row' : 'none',
                          }}
                        >
                          <td style={{ ...planCarryAnCellStyle, fontSize: FONT_SIZE_14 }}> 焼却負荷率</td>
                        </tr>
                      </>
                    ))}
                    <tr style={{ ...planCarryRowStyle, display: showPitVisible && !isMonthDisplay() ? 'table-row' : 'none' }}>
                      <td
                        style={{
                          ...planCarryAnCellStyle,
                          fontSize: FONT_SIZE_14,
                        }}
                        colSpan={2}
                      >
                        ピット残量[t]
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
            <table
              style={{
                borderCollapse: 'collapse',
                overflowX: 'auto',
                zIndex: 1,
              }}
            >
              <tbody>
                {Array.from({ length: draftResource.length }).map((_, draftIndex) => (
                  <>
                    <tr style={planCarryRowStyle}>
                      {Array.from({
                        length: isMonthDisplay() ? displayDays[draftIndex].length : displayDays[draftIndex][selectMonthIndex - 1],
                      }).map((_, colIndex) => (
                        <td
                          style={{
                            ...planCarryCellStyle,
                            background: '#007f89',
                            color: '#FFFFFF',
                          }}
                        >
                          {isMonthDisplay() ? months[colIndex] + '月' : colIndex + 1 + '日'}
                        </td>
                      ))}
                    </tr>
                    <tr
                      style={{
                        ...planCarryRowStyle,
                        display: isResultDraft.some((value) => value) ? 'table-row' : 'none',
                      }}
                    >
                      {Array.from({
                        length: isMonthDisplay() ? displayDays[draftIndex].length : displayDays[draftIndex][selectMonthIndex - 1],
                      }).map((_, colIndex) => (
                        <td
                          style={{
                            ...planCarryCellStyle,
                          }}
                        >
                          {isMonthDisplay()
                            ? draftResource[draftIndex]
                              ? draftResource[draftIndex].month[colIndex].date !== ''
                                ? addComma(
                                    calcMathRound(
                                      itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_carry_volume, draftIndex)[colIndex],
                                      CARRY_BLUR_DIGIT,
                                    ),
                                  )
                                : ''
                              : ''
                            : draftResource[draftIndex].day[daySum(draftIndex, selectMonthIndex - 1) + colIndex].date !== ''
                            ? addComma(
                                calcMathRound(
                                  itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_carry_volume, draftIndex)[colIndex],
                                  CARRY_BLUR_DIGIT,
                                ),
                              )
                            : ''}
                        </td>
                      ))}
                    </tr>
                    {Array.from({ length: sessionFurnacesCount }).map((_, furnacesIndex) => (
                      <>
                        <tr
                          style={{
                            ...planCarryRowStyle,
                            display: showBurnVisible ? 'table-row' : 'none',
                          }}
                        >
                          {Array.from({
                            length: isMonthDisplay() ? displayDays[draftIndex].length : displayDays[draftIndex][selectMonthIndex - 1],
                          }).map((_, colIndex) => (
                            <td style={planCarryCellStyle}>
                              {isMonthDisplay()
                                ? draftResource[draftIndex].month[colIndex].date !== ''
                                  ? addComma(
                                      calcMathRound(
                                        burnDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_burn_volume, furnacesIndex, draftIndex)[colIndex],
                                        BURNVOLUME_BLUR_DIGIT,
                                      ),
                                    )
                                  : ''
                                : draftResource[draftIndex].day[daySum(draftIndex, selectMonthIndex - 1) + colIndex].date !== ''
                                ? addComma(
                                    calcMathRound(
                                      burnDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_burn_volume, furnacesIndex, draftIndex)[colIndex],
                                      BURNVOLUME_BLUR_DIGIT,
                                    ),
                                  )
                                : ''}
                            </td>
                          ))}
                        </tr>
                        <tr
                          style={{
                            ...planCarryRowStyle,
                            display: showBurnVisible && isMonthDisplay() ? 'table-row' : 'none',
                          }}
                        >
                          {Array.from({
                            length: displayDays[draftIndex].length,
                          }).map((_, colIndex) => (
                            <td
                              style={{
                                ...planCarryCellStyle,
                              }}
                            >
                              {draftResource[draftIndex].month[colIndex].date !== ''
                                ? addComma(calcMathFloor(draftResource[draftIndex].month[colIndex].burn_load[furnacesIndex], BURNLOAD_DIGIT))
                                : ''}
                            </td>
                          ))}
                        </tr>
                      </>
                    ))}
                    <tr
                      style={{
                        ...planCarryRowStyle,
                        display: showPitVisible && !isMonthDisplay() ? 'table-row' : 'none',
                      }}
                    >
                      {Array.from({
                        length: displayDays[draftIndex][selectMonthIndex - 1],
                      }).map((_, colIndex) => (
                        <td
                          style={{
                            ...planCarryCellStyle,
                          }}
                        >
                          {draftResource[draftIndex].day[daySum(draftIndex, selectMonthIndex - 1) + colIndex].date !== ''
                            ? addComma(calcMathRound(draftResource[draftIndex].day[daySum(draftIndex, selectMonthIndex - 1) + colIndex].trash_pit_rest, TRASH_PIT_DIGIT))
                            : ''}
                        </td>
                      ))}
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
            <table style={{ borderCollapse: 'collapse', minWidth: '50px' }}>
              <tbody>
                {Array.from({ length: draftResource.length }).map((_, draftIndex) => (
                  <>
                    <tr style={{ ...planCarryRowStyle, textAlign: 'center' }}>
                      <td style={{ ...planCarryCellStyle, background: '#007f89', color: '#FFFFFF' }}>合計値</td>
                    </tr>
                    <tr
                      style={{
                        ...planCarryRowStyle,
                        display: isResultDraft.some((value) => value) ? 'table-row' : 'none',
                      }}
                    >
                      <td style={planCarryCellStyle}>
                        {isMonthDisplay()
                          ? draftResource[draftIndex]
                            ? addComma(calcMathRound(calcItemSum(draftResource[draftIndex].month, item_carry_volume), CARRY_BLUR_DIGIT))
                            : ''
                          : addComma(calcMathRound(calcItemSum(getMonthData(draftResource[draftIndex].day, draftIndex), item_carry_volume), CARRY_BLUR_DIGIT))}
                      </td>
                    </tr>
                    {Array.from({ length: sessionFurnacesCount }).map((_, furnacesIndex) => (
                      <>
                        <tr
                          style={{
                            ...planCarryRowStyle,
                            display: isResultDraft[draftIndex] && showBurnVisible ? 'table-row' : 'none',
                          }}
                        >
                          <td style={planCarryCellStyle}>
                            {isMonthDisplay()
                              ? addComma(calcMathRound(calcItemBurnSum(draftResource[draftIndex].month, furnacesIndex), BURNVOLUME_BLUR_DIGIT))
                              : addComma(calcMathRound(calcItemBurnSum(getMonthData(draftResource[draftIndex].day, draftIndex), furnacesIndex), BURNVOLUME_BLUR_DIGIT))}
                          </td>
                        </tr>
                        <tr
                          style={{
                            ...planCarryRowStyle,
                            display: isResultDraft[draftIndex] && showBurnVisible && isMonthDisplay() ? 'table-row' : 'none',
                          }}
                        >
                          <td style={planCarryCellStyle}>
                            {isMonthDisplay() ? (resultBurnLoads.length > 0 ? (resultBurnLoads[draftIndex] ? addComma(resultBurnLoads[draftIndex][furnacesIndex]) : '') : '') : ''}
                          </td>
                        </tr>
                      </>
                    ))}
                    <tr style={{ ...planCarryRowStyle, textAlign: 'center', display: showPitVisible && !isMonthDisplay() ? 'table-row' : 'none' }}>
                      <td style={{ ...planCarryCellStyle, backgroundImage: 'linear-gradient(35deg, transparent 49%, black 50%, transparent 51%)' }}></td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div style={{ ...indentStyle, display: showShutdownVisible ? 'inline-block' : 'none', overflowX: 'visible' }}>
        <div style={{ ...graphTitleStyle, height: '35px' }}>
          <div style={{ ...graphTitleBackStyle, marginLeft: '5px' }}>立上下日</div>
        </div>
        <div style={rowStyle}>
          <div style={{ ...l1_BurnGraphStyle }}>
            {Array.from({ length: draftResource.length }).map((_, draftIndex) => (
              <>
                {Array.from({ length: sessionFurnacesCount }).map((_, furnacesIndex) => (
                  <div
                    style={{
                      display: isResultDraft[draftIndex] ? 'flex' : 'none',
                      flexDirection: 'row',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: colorList[displayYearList[draftIndex] % colorList.length],
                        whiteSpace: 'pre-line',
                        fontSize: 14,
                        textAlign: 'center',
                        alignContent: 'center',
                        border: 'solid 1px black',
                        height: '100px',
                        maxHeight: '100px',
                        minWidth: '45px',
                      }}
                    >
                      {String(furnacesIndex + 1).concat('号炉')}
                    </div>
                    <div
                      style={{
                        backgroundColor: colorList[displayYearList[draftIndex] % colorList.length],
                        whiteSpace: 'pre-line',
                        fontSize: 14,
                        textAlign: 'center',
                        alignContent: 'center',
                        border: 'solid 1px black',
                        height: '100px',
                        maxHeight: '100px',
                        minWidth: '75px',
                      }}
                    >
                      {`運転・停止`}
                      <br />
                      {String(displayYearList[draftIndex]).concat('年度')}
                    </div>
                    <div
                      style={{
                        textAlign: 'center',
                        alignContent: 'center',
                        maxHeight: '100px',
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: colorList[displayYearList[draftIndex] % colorList.length],
                          fontSize: 14,
                          textAlign: 'center',
                          alignContent: 'center',
                          border: 'solid 1px black',
                          height: '50px',
                          maxHeight: '50px',
                          minWidth: '60px',
                        }}
                      >
                        立上日
                      </div>
                      <div
                        style={{
                          backgroundColor: colorList[displayYearList[draftIndex] % colorList.length],
                          fontSize: 14,
                          textAlign: 'center',
                          alignContent: 'center',
                          border: 'solid 1px black',
                          height: '50px',
                          maxHeight: '50px',
                          minWidth: '60px',
                        }}
                      >
                        立下日
                      </div>
                    </div>
                    <div
                      style={{
                        maxHeight: '100px',
                        width: '875px',
                        border: 'solid 1px black',
                      }}
                    >
                      <div style={{ overflow: 'hidden', maxHeight: '50px' }}>
                        <BurnGraph3
                          dayStr={shutDownSums(item_launch_date, draftResource[draftIndex].shutdown[furnacesIndex], draftIndex)}
                          directionY="Bottom"
                          dayCount={displayDays[draftIndex]}
                          monthIndex={selectMonthIndex}
                        ></BurnGraph3>
                      </div>
                      <div style={{ overflow: 'hidden', maxHeight: '50px' }}>
                        <BurnGraph2
                          dayCount={isMonthDisplay() ? months.length : displayDays[draftIndex][selectMonthIndex - 1]}
                          planArray={burnDraftDaysVolumes(draftResource[draftIndex].day, item_burn_volume, furnacesIndex, draftIndex)}
                          rateCapacity={conditionResource.rateCapacity}
                        ></BurnGraph2>
                      </div>
                      <div style={{ overflow: 'hidden', maxHeight: '50px' }}>
                        <BurnGraph3
                          dayStr={shutDownSums(item_shutdown_date, draftResource[draftIndex].shutdown[furnacesIndex], draftIndex)}
                          directionY="Top"
                          dayCount={displayDays[draftIndex]}
                          monthIndex={selectMonthIndex}
                        ></BurnGraph3>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ))}
          </div>
        </div>
      </div>

      <div style={indentStyle}>
        <div style={rowStyle}>
          <div style={{ ...l1_PlanGraphStyle, display: showPitVisible ? 'inline-block' : 'none' }}>
            <div style={graphTitleStyle}>
              <div style={{ ...graphTitleBackStyle }}>ごみピット残量</div>
            </div>
            <PitGraph
              lineTitles={displayYearList.map((year) => String(year).concat('年度 ごみピット残量'))}
              dayCount={isMonthDisplay() ? DEF_MONTH_NUMS : [Math.max(...displayDays.map((day) => day[selectMonthIndex - 1] ?? 0))]}
              minLimit={conditionResource.pitMin * conditionResource.trashDensity}
              maxLimit={conditionResource.pitMax * conditionResource.trashDensity}
              autoDraft={Array.from({ length: draftResource.length }, (_, draftIndex) =>
                isMonthDisplay()
                  ? selectItemArray(draftResource[draftIndex].day, item_trash_pit_rest)
                  : itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_trash_pit_rest, draftIndex),
              )}
              isSelect={[...isResultDraft]}
            />
          </div>
        </div>
        <div style={rowStyle}>
          <div style={{ ...l1_PlanGraphStyle, display: showPowerVisible ? 'inline-block' : 'none' }}>
            <div style={graphTitleStyle}>
              <div style={{ ...graphTitleBackStyle }}>発電量</div>
            </div>
            <div style={l2_PlanGraphStyle}>
              <div style={{ width: 'calc(100% - 200px)' }}>
                <ElectricGraph2
                  lineTitles={displayYearList.map((str) => String(str).concat('年度 発電量'))}
                  dayCount={isMonthDisplay() ? months.length : Math.max(...displayDays.map((day) => day[selectMonthIndex - 1] ?? 0))}
                  autoDraft={[
                    ...Array.from({ length: draftResource.length }, (_, draftIndex) =>
                      convertMWhArray(itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_electric_create, draftIndex)),
                    ),
                  ]}
                  isSelect={[...isResultDraft]}
                ></ElectricGraph2>
              </div>
              <ElectricSumGraph2
                lineTitles={displayYearList.map((str) => String(str).concat('年度 発電量'))}
                dayCount={isMonthDisplay() ? months.length : Math.max(...displayDays.map((day) => day[selectMonthIndex - 1] ?? 0))}
                autoDraft={[
                  ...Array.from({ length: draftResource.length }, (_, draftIndex) =>
                    convertMWhArray(itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_electric_create, draftIndex)),
                  ),
                ]}
                isSelect={[...isResultDraft]}
                unit={'MWh'}
              ></ElectricSumGraph2>
            </div>
          </div>
        </div>
        <div style={rowStyle}>
          <div style={{ ...l1_PlanGraphStyle, display: showPowerVisible ? 'inline-block' : 'none' }}>
            <div style={graphTitleStyle}>
              <div style={{ ...graphTitleBackStyle }}>売電量</div>
            </div>
            <div style={l2_PlanGraphStyle}>
              <div style={{ width: 'calc(100% - 200px)' }}>
                <ElectricGraph2
                  lineTitles={displayYearList.map((str) => String(str).concat('年度 売電量'))}
                  dayCount={isMonthDisplay() ? months.length : Math.max(...displayDays.map((day) => day[selectMonthIndex - 1] ?? 0))}
                  autoDraft={[
                    ...Array.from({ length: draftResource.length }, (_, draftIndex) =>
                      convertMWhArray(itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_electric_sale, draftIndex)),
                    ),
                  ]}
                  isSelect={[...isResultDraft]}
                ></ElectricGraph2>
              </div>
              <ElectricSumGraph2
                lineTitles={displayYearList.map((str) => String(str).concat('年度 売電量'))}
                dayCount={isMonthDisplay() ? months.length : Math.max(...displayDays.map((day) => day[selectMonthIndex - 1] ?? 0))}
                autoDraft={[
                  ...Array.from({ length: draftResource.length }, (_, draftIndex) =>
                    convertMWhArray(itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_electric_sale, draftIndex)),
                  ),
                ]}
                isSelect={[...isResultDraft]}
                unit={'MWh'}
              ></ElectricSumGraph2>
            </div>
          </div>
        </div>
        <div style={rowStyle}>
          <div style={{ ...l1_PlanGraphStyle, display: showAshVisible ? 'inline-block' : 'none' }}>
            <div style={graphTitleStyle}>
              <div style={{ ...graphTitleBackStyle }}>主灰搬出量</div>
            </div>
            <div style={l2_PlanGraphStyle}>
              <div style={{ width: 'calc(100% - 200px)' }}>
                <AshGraph
                  lineTitles={displayYearList.map((str) => String(str).concat('年度 主灰搬出量'))}
                  barTitles={displayYearList.map((str) => String(str).concat('年度 主灰搬入台数'))}
                  dayCount={isMonthDisplay() ? months.length : Math.max(...displayDays.map((day) => day[selectMonthIndex - 1] ?? 0))}
                  lineDatas={[
                    ...Array.from({ length: draftResource.length }, (_, draftIndex) =>
                      itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_main_ash_carry, draftIndex),
                    ),
                  ]}
                  barDatas={[
                    ...Array.from({ length: draftResource.length }, (_, draftIndex) =>
                      itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_main_ash_unit, draftIndex),
                    ),
                  ]}
                  isSelect={[...isResultDraft]}
                ></AshGraph>
              </div>

              <ElectricSumGraph2
                lineTitles={displayYearList.map((str) => String(str).concat('年度 灰搬出量'))}
                dayCount={isMonthDisplay() ? months.length : Math.max(...displayDays.map((day) => day[selectMonthIndex - 1] ?? 0))}
                autoDraft={[
                  ...Array.from({ length: draftResource.length }, (_, draftIndex) =>
                    itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_main_ash_carry, draftIndex),
                  ),
                ]}
                isSelect={[...isResultDraft]}
                unit={'t'}
              ></ElectricSumGraph2>
            </div>
          </div>
        </div>
        <div style={rowStyle}>
          <div style={{ ...l1_PlanGraphStyle, display: showAshVisible ? 'inline-block' : 'none' }}>
            <div style={graphTitleStyle}>
              <div style={{ ...graphTitleBackStyle }}>飛灰搬出量</div>
            </div>
            <div style={l2_PlanGraphStyle}>
              <div style={{ width: 'calc(100% - 200px)' }}>
                <AshGraph
                  lineTitles={displayYearList.map((str) => String(str).concat('年度 飛灰搬出量'))}
                  barTitles={displayYearList.map((str) => String(str).concat('年度 飛灰搬入台数'))}
                  dayCount={isMonthDisplay() ? months.length : Math.max(...displayDays.map((day) => day[selectMonthIndex - 1] ?? 0))}
                  lineDatas={[
                    ...Array.from({ length: draftResource.length }, (_, draftIndex) =>
                      itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_fly_ash_carry, draftIndex),
                    ),
                  ]}
                  isSelect={[...isResultDraft]}
                  barDatas={[
                    ...Array.from({ length: draftResource.length }, (_, draftIndex) =>
                      itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_fly_ash_unit, draftIndex),
                    ),
                  ]}
                ></AshGraph>
              </div>
              <ElectricSumGraph2
                lineTitles={displayYearList.map((str) => String(str).concat('年度 飛灰搬出量'))}
                dayCount={isMonthDisplay() ? months.length : Math.max(...displayDays.map((day) => day[selectMonthIndex - 1] ?? 0))}
                autoDraft={[
                  ...Array.from({ length: draftResource.length }, (_, draftIndex) =>
                    itemDraftVolumes(draftResource[draftIndex].month, draftResource[draftIndex].day, item_fly_ash_carry, draftIndex),
                  ),
                ]}
                isSelect={[...isResultDraft]}
                unit={'t'}
              ></ElectricSumGraph2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page;
